import { Helmet } from "react-helmet-async";

export default function SEO({ 
  title, 
  description, 
  keywords,
  image,
  url,
  type = "website",
  schema,
  // Defaults to the Darwin suffix, which is right for the pages our own
  // team serves. Network service areas pass "Aussie Inspections" so a Sydney
  // page is not titled "... | Aussie Inspections Darwin".
  titleSuffix = "Aussie Inspections Darwin"
}) {
  const siteUrl = "https://aussieinspections.com.au";
  const defaultImage = `${siteUrl}/logo.png`;
  
  const fullTitle = title ? `${title} | ${titleSuffix}` : "Aussie Inspections - Building & Property Inspections Darwin NT";
  const fullUrl = url ? `${siteUrl}${url}` : siteUrl;
  const fullImage = image || defaultImage;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:site_name" content="Aussie Inspections" />
      <meta property="og:locale" content="en_AU" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />

      {/* Additional Meta Tags */}
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      <meta name="author" content="Aussie Inspections" />
      <meta name="geo.region" content="AU-NT" />
      <meta name="geo.placename" content="Darwin" />
      <meta name="geo.position" content="-12.4634;130.8456" />
      <meta name="ICBM" content="-12.4634, 130.8456" />

      {/* Schema.org Structured Data */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
}
